import React from 'react';
import { cn } from '@/lib/utils';

interface MobileInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
}

export const MobileInput = React.forwardRef<HTMLInputElement, MobileInputProps>(
    ({ label, error, className, ...props }, ref) => {
        return (
            <div className="space-y-2">
                {label && (
                    <label className="text-sm font-medium text-foreground">
                        {label}
                    </label>
                )}
                <input
                    ref={ref}
                    className={cn(
                        'mobile-input',
                        error && 'border-destructive focus:ring-destructive',
                        className
                    )}
                    {...props}
                />
                {error && (
                    <p className="text-xs text-destructive">{error}</p>
                )}
            </div>
        );
    }
);

MobileInput.displayName = 'MobileInput';
